import { useState, useEffect, useRef } from "react";
import { api } from "../lib/api";
import { Search, X } from "lucide-react";

const ParentSelector = ({ label, value, selectedName, onChange, excludeId, testId }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    if (!q || q.length < 1) { setResults([]); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/horses/search", { params: { q, exclude: excludeId, limit: 8 } });
        setResults(data);
      } catch { setResults([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, excludeId]);

  useEffect(() => {
    const handler = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const choose = (h) => {
    onChange(h.id, h.name);
    setQ(""); setResults([]); setOpen(false);
  };

  return (
    <div className="relative" ref={boxRef}>
      <label className="text-sm font-bold text-[#5C4F42] mb-1 block">{label}</label>
      {value ? (
        <div className="flex items-center justify-between bg-[#F0EBE1] border border-[#D6CFC4] rounded px-3 py-2">
          <span className="text-[#2C241B] font-bold">{selectedName}</span>
          <button type="button" onClick={() => onChange(null, null)} className="text-[#8B2500]" data-testid={`${testId}-clear`}>
            <X size={16} />
          </button>
        </div>
      ) : (
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C4F42]" />
          <input
            type="text"
            value={q}
            onFocus={() => setOpen(true)}
            onChange={(e) => { setQ(e.target.value); setOpen(true); }}
            placeholder="Нэр/Бүртгэл/Микрочипээр хайх..."
            className="w-full border border-[#D6CFC4] rounded pl-9 pr-3 py-2 focus:outline-none focus:border-[#B8860B]"
            data-testid={testId}
          />
          {open && results.length > 0 && (
            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-[#D6CFC4] rounded shadow-lg z-20 max-h-64 overflow-auto">
              {results.map((h) => (
                <button
                  key={h.id}
                  type="button"
                  onClick={() => choose(h)}
                  className="w-full text-left px-3 py-2 hover:bg-[#F0EBE1] border-b border-[#D6CFC4] last:border-0"
                  data-testid={`${testId}-option-${h.id}`}
                >
                  <div className="text-sm font-bold text-[#1B3B5A]">{h.name}</div>
                  <div className="text-xs text-[#5C4F42]">
                    {[h.gender, h.color, h.birth_year && `${h.birth_year} он`, h.registration_number && `№${h.registration_number}`, h.microchip && `чип: ${h.microchip}`].filter(Boolean).join(" · ")}
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ParentSelector;
